<!-- 由 suu 创建于 2022-02-28 星期一 -->
<template>
  <div class="fat-reduction">
    <!-- 用户信息 -->
    <div v-if="user" class="ac_header">
      <div class="ac_h_left">
        <img :src="user.member_image" class="ac_h_image" />
        <div>
          <div class="ac_h_name">{{ user.member_name }}</div>
          <div class="ac_h_shop">{{ user.shop_name }}</div>
        </div>
      </div>
      <div class="ac_h_right">
        <img :src="logoPng" class="ac_h_logo" />
        <div class="ac_h_title">减脂大作战</div>
      </div>
    </div>
    <!-- 专属教练信息 -->
    <div class="ac_main">
      <div class="ac_m_one" v-if="coach">
        <div class="ac_mo_left">
          <img :src="coach.image" />
          <div>
            <div class="ac_mol_up">
              <div class="ac_mol_name">{{ coach.name }}</div>
              <div class="ac_mol_sub">专属教练</div>
            </div>
            <div class="ac_mol_tabs">
              <template v-for="(item, index) in coach.feature">
                <div :key="index" class="ac_mol_item">{{ item }}</div>
              </template>
            </div>
          </div>
        </div>
        <div class="ac_mo_right">
          <div class="ac_mor_title">好评度</div>
          <div class="ac_mor_num">{{ coach.avg_score }}</div>
        </div>
      </div>
      <template v-if="course">
        <div v-for="(item, index) in course" :key="index" class="ac_m_two">
          <div class="ac_mt_title">
            {{ `已预约：${item.course_name} ${item.coach_name}` }}
          </div>
          <div class="ac_mt_right">
            <div>{{ item.time.substr(0, 16).replace(/\-/g, '.') }}</div>
            <i class="iconfont icon-guanbi" @click="tapCancel(item)" />
          </div>
        </div>
      </template>
      <ReductionProgress
        title="课程进度"
        :finish="finishNum"
        :step="curStep"
        :list="courseList"
      />
      <div class="ac_m_btns">
        <div class="ac_mb_appint" @click="goClass">自助约课</div>
        <div class="ac_mb_special" @click="specialClass">
          <div class="ac_mbs_title">特殊约课</div>
          <div class="ac_mbs_rate" v-if="rate">{{ `履约率${rate}` }}</div>
          <div class="ac_mbs_flag" @click.stop="tapSpecial">特权</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReductionProgress from './ponents/ReductionProgress.vue'
export default {
  name: 'fat-reduction',

  components: { ReductionProgress },

  props: {},

  data() {
    return {
      logoPng: 'https://cdnvue.gymcity.com.cn/uploads/pub-white-logo',
      coach: null,
      user: null,
      course: null,
      finishNum: '',
      curStep: '',
      rate: '',
      courseList: []
    }
  },

  computed: {},

  watch: {},

  created() {
    this.getInfo()
  },

  mounted() {},

  destroyed() {},

  methods: {
    // 用户信息
    getInfo() {
      let params = { a: 'schedule_info' }
      this.$toast.loading('加载中...')
      this.$http
        .get('member/ReduceFatBattle', params)
        .then((rs) => {
          this.$toast.clear()
          if (rs.data.code === 200) {
            let result = rs.data.data
            this.datum = result
            this.user = result.member_info
            this.coach = result.coach_card
            this.course = result.appointment_list
            this.curStep = result.current_course_num
            this.finishNum = result.have_class_num
            this.courseList = result.courses
            this.rate = result.performance_rate
            this.timeLeft = result.get_coupons_time_left
            // this.showSendHPop()
          } else {
            this.$dialog.alert({ message: rs.data.msg })
          }
        })
        .catch((err) => {
          this.$toast.clear()
        })
    },
    // 约课
    goClass() {
      // 获取教练信息
      let params = {
        a: 'coachCard',
        cid: this.coach.coachid
      }
      this.$toast.loading('加载中···')
      this.$http
        .get('member/active', params)
        .then((rs) => {
          this.$toast.clear()
          if (rs.data.code === 200 && rs.data.data) {
            this.toDetail(this.coach.coachid, rs.data.data)
          } else {
            this.$dialog({ message: rs.data.msg })
          }
        })
        .catch((err) => {
          this.$$dialog({ message: '网络错误' })
          this.$toast.clear()
        })
    },
    /**
     * 自主约课 跳转教练排课详情
     * @param cid 教练ID
     * @param obj 教练信息
     */
    toDetail(cid, obj) {
      let detailData = obj
      let currDay = this._getCurDay()
      // 教练详情默认请求此日期的排课信息
      detailData['coursetime'] = currDay
      if (Object.keys(detailData).length > 0) {
        this.$store.commit('setDetailData', detailData)
        this.$store.commit('setCurrDay', currDay)
        this.$router.push({
          path: '/subscribe/detail',
          query: { isreduce: 1 }
        })
      }
    },
    // 取消课程-按钮
    tapCancel(item) {
      let str = ''
      let obj = {
        ...item,
        ...{
          starttime: new Date(item.time.replace(/-/g, '/')).getTime() / 1000,
          updatetime:
            new Date(item.create_time.replace(/-/g, '/')).getTime() / 1000
        }
      }
      let stime = obj.starttime
      let ctime = obj.updatetime
      let now = Date.now() / 1000
      const date3 = Math.abs(obj.starttime * 1000 - Date.now())
      let days = Math.floor(date3 / (24 * 3600 * 1000)) + '天'
      let leave1 = date3 % (24 * 3600 * 1000)
      let hours = Math.floor(leave1 / (3600 * 1000))
      let leave2 = leave1 % (3600 * 1000)
      let minutes = Math.floor(leave2 / (60 * 1000))
      if (days[0] === '0') days = ''
      if (Math.abs(now - ctime) < 600) {
        str = '本次取消在约课后 10分钟内，不扣除经验值'
      } else {
        if (Math.abs(stime - now) < (60 + 55) * 60) {
          str = `距离上课时间：${
            days + hours
          }小时${minutes}分，取消本次约课将扣除经验值20分`
        } else if (Math.abs(stime - now) < (60 * 3 + 55) * 60) {
          str = `距离上课时间：${
            days + hours
          }小时${minutes}分，取消本次约课将扣除经验值5分`
        } else {
          str = `本次取消在上课 前4小时，不扣除经验值`
        }
      }
      this.$dialog
        .confirm({ message: str, title: '确认取消？' })
        .then(() => {
          this.cancelClass(item.ma_id)
        })
        .catch(() => {})
    },
    // 取消课程-接口
    cancelClass(id) {
      let params = { id }
      this.$toast.loading('取消预约中...')
      this.$http
        .delete2('index/ordered', params)
        .then((v) => {
          this.$toast.clear()
          if (v.data.msg === '预约的课程已确认取消') {
            this.$toast('取消成功')
            this.getInfo()
          } else {
            this.$dialog({ message: v.data.msg })
          }
        })
        .catch(() => {
          this.$toast.clear()
          this.$dialog({ message: '数据错误请刷新重进' })
        })
    },
    // 特殊说明
    tapSpecial() {
      let message =
        '使用特权约课，可和教练单独约定上课时间，仅限减脂营会员使用，当履约率低于90%时，该特权无法使用。'
      this.$dialog.alert({ message })
    },
    // 特殊约课-按钮
    specialClass() {
      this.$dialog
        .confirm({
          message:
            '此操作将通知提醒您的专属教练帮您约课，稍后将与您联系沟通具体上课时间，是否继续？'
        })
        .then(() => {
          this.specialUpload()
        })
        .catch(() => {})
    },
    // 特殊约课-接口
    specialUpload() {
      let params = {
        a: 'privilege_appointment',
        coach_id: this.coach.coachid,
        member_name: this.user.member_name
      }
      this.$toast.loading('加载中···')
      this.$http
        .get('member/ReduceFatBattle', params)
        .then((rs) => {
          this.$toast.clear()
          this.$dialog({
            message: '已成功提醒您的专属教练，稍后将与您取得联系，请耐心等待！'
          })
        })
        .catch(() => {
          this.$toast.clear()
        })
    },
    //  * 获取当日 格式
    _getCurDay() {
      const week = ['日', '一', '二', '三', '四', '五', '六']
      const date = new Date()
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1)[1]
        ? String(date.getMonth() + 1)
        : '0' + String(date.getMonth() + 1)
      const day = String(date.getDate())[1]
        ? String(date.getDate())
        : '0' + String(date.getDate())
      let obj = {
        a_day: year + '-' + month + '-' + day,
        day: date.getMonth() + 1 + '-' + day,
        week: week[date.getDay()]
      }
      return obj
    },
    _today() {
      let day = new Date()
      let yy = day.getFullYear()
      let mm = this._fillNum(day.getMonth() + 1)
      let dd = this._fillNum(day.getDate())
      return `${yy}-${mm}-${dd}`
    },
    // 补0方法
    _fillNum(val) {
      return ('00' + val).slice(String(val).length)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.fat-reduction {
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  background: #f1f1f1;
  padding-bottom: 16vw;
  .ac_header {
    height: 56vw;
    padding: 3.5vw 2.7vw;
    box-sizing: border-box;
    background-image: linear-gradient(180deg, #dc0050 0%, #dc0050 100%);
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    color: #fff;
    .ac_h_left {
      display: flex;
      align-items: center;
      text-align: left;
      .ac_h_image {
        margin-right: 1.9vw;
        width: 12.4vw;
        height: 12.4vw;
        background-color: #d8d8d8;
        border-radius: 2.1vw;
      }
      .ac_h_name {
        font-size: 4.37vw;
        font-weight: 600;
      }
      .ac_h_shop {
        font-size: 3.7vw;
      }
    }
    .ac_h_right {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .ac_h_logo {
        width: 29.9vw;
        object-fit: cover;
      }
      .ac_h_title {
        font-size: 8.5vw;
        font-weight: 600;
      }
    }
  }
  .ac_main {
    margin: -34.2vw auto 0;
    width: 94.7vw;
    padding: 4.3vw 4vw;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 1.6vw;
    .ac_m_one {
      display: flex;
      justify-content: space-between;
      .ac_mo_left {
        display: flex;
        color: #000;
        text-align: left;
        & > img {
          margin-right: 3.2vw;
          width: 12.8vw;
          height: 12.8vw;
          background-color: #d8d8d8;
          border-radius: 1.6vw;
        }
        .ac_mol_up {
          display: flex;
          align-items: center;
          .ac_mol_name {
            font-size: 5.3vw;
            font-weight: 600;
          }
          .ac_mol_sub {
            margin-left: 2.7vw;
            font-size: 3.5vw;
          }
        }
        .ac_mol_tabs {
          margin-top: 0.8vw;
          display: flex;
          .ac_mol_item + .ac_mol_item {
            margin-left: 1.6vw;
          }
          .ac_mol_item {
            padding: 0.6vw 2.1vw;
            font-size: 3.2vw;
            font-weight: 600;
            color: #000;
            background-color: #f1f1f1;
            border-radius: 0.5vw;
          }
        }
      }
      .ac_mo_right {
        text-align: right;
        .ac_mor_title {
          font-size: 3.2vw;
          color: rgba(0, 0, 0, 0.5);
        }
        .ac_mor_num {
          font-size: 8vw;
          font-weight: 600;
          color: #dc0050;
        }
      }
    }
    .ac_m_two {
      margin-top: 2vw;
      padding: 3vw 4vw;
      background-color: #fff;
      border-radius: 1.6vw;
      border: solid 0.3vw #f1f1f1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 3.2vw;
      .ac_mt_title {
        color: #000;
      }
      .ac_mt_right {
        display: flex;
        align-items: center;
        color: #dc0050;
        & > i {
          margin-left: 2.6vw;
          font-size: 3vw;
          color: #d8d8d8;
        }
      }
    }
    .ac_m_btns {
      margin-top: 4vw;
      display: flex;
      justify-content: space-between;
      align-items: center;
      & > div {
        width: 41.9vw;
        height: 11.7vw;
        border-radius: 1.6vw;
        &:active {
          transform: scale(0.98);
        }
      }
      .ac_mb_appint {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 4vw;
        font-weight: 600;
        color: #fff;
        background-image: linear-gradient(180deg, #dc0050 0%, #dc0050 100%);
      }
      .ac_mb_special {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #fff9e9;
        border: solid 0.3vw #ffe9ad;
        position: relative;
        overflow: hidden;
        .ac_mbs_title {
          font-size: 4vw;
          font-weight: 600;
          color: #000;
        }
        .ac_mbs_rate {
          font-size: 2.7vw;
          color: rgba(0, 0, 0, 0.5);
        }
        .ac_mbs_flag {
          position: absolute;
          right: -10vw;
          top: -8vw;
          font-size: 2.7vw;
          font-weight: 600;
          color: #ffe6a3;
          background-color: #383d48;
          width: 19vw;
          height: 15vw;
          padding-bottom: 0.4vw;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: flex-end;
          transform: rotate(45deg);
        }
      }
    }
  }
}
</style>
